var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarwinds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9742 23.3965C23.1281 23.3458 23.2307 23.3458 23.3332 23.295C26.1537 22.4828 28.8717 21.4168 31.6409 20.3C34.3075 19.1832 36.9229 17.8633 39.2819 15.9851C41.6408 14.0561 43.5383 11.5687 44.6152 8.5229C44.769 8.11679 45.0767 7.45687 45.0767 7C41.3844 12.0256 26.6665 12.5332 26.6665 12.5332L30.1537 9.38587C16.2051 9.43663 6.46152 15.2744 2 18.4217C7.69228 19.0309 12.8717 21.4168 16.923 25.0209C18.923 24.4118 20.9743 23.9549 22.9742 23.3965Z",
    fill: "#F99D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22.8892C46 22.8892 32.4615 21.8739 18.3589 26.3411C20.205 28.2701 21.7948 30.5037 23.0256 32.8896C30.4102 28.8793 40.718 23.6506 46 22.8892Z",
    fill: "#F99D1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9486 35.0212C24.8204 37.204 25.3845 39.5391 25.6409 41.9757L38.5641 28.8281L23.9486 35.0212Z",
    fill: "#F99D1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarwinds);
export default __webpack_public_path__ + "static/media/Solarwinds.91c1efef.svg";
export { ForwardRef as ReactComponent };